



























export default {
    name: 'AlertError',

    props: {
        message: {
            required: true,
            type: String,
        },

        dismissible: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
